var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 8,
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4C17 4.29999 16.7761 4.54319 16.5 4.54319H1.70711L4.03553 7.07272C4.2308 7.28485 4.2308 7.62878 4.03553 7.8409C3.84027 8.05303 3.52369 8.05303 3.32843 7.8409L0.146446 4.38409C-0.0488148 4.17196 -0.0488148 3.82804 0.146446 3.61591L3.32843 0.159095C3.52369 -0.0530318 3.84027 -0.0530318 4.03553 0.159095C4.2308 0.371223 4.2308 0.715149 4.03553 0.927276L1.70711 3.45681L16.5 3.45681C16.7761 3.45681 17 3.70001 17 4Z",
    fill: "#BBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBack);
export default __webpack_public_path__ + "static/media/icon-arrow-back.57a5d312e774ba8d72872e10408faf54.svg";
export { ForwardRef as ReactComponent };